/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolWarehouseIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-warehouse"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M1.68 18.68L1.68 8.57Q1.68 7.78 2.14 7.09Q2.6 6.4 3.35 6.1L11.03 3.05Q11.5 2.85 12 2.85Q12.5 2.85 12.97 3.05L20.65 6.1Q21.4 6.4 21.86 7.09Q22.32 7.78 22.32 8.57L22.32 18.68Q22.32 19.8 21.56 20.56Q20.8 21.32 19.68 21.32L15.93 21.32L15.93 13.47Q15.93 13.47 15.93 13.47Q15.93 13.47 15.93 13.47L8.07 13.47Q8.07 13.47 8.07 13.47Q8.07 13.47 8.07 13.47L8.07 21.32L4.33 21.32Q3.2 21.32 2.44 20.56Q1.68 19.8 1.68 18.68ZM8.93 21.32L8.93 18.68L11.57 18.68L11.57 21.32ZM10.68 17.82L10.68 15.18L13.32 15.18L13.32 17.82ZM12.43 21.32L12.43 18.68L15.07 18.68L15.07 21.32Z" fill={color} />
    </svg>
  );
}
